/* traversine-t1.js — selettore confezione delle landing traversine.
 *
 * Nato per la landing T1, dal 25/09/2026 lo usa anche la landing principale
 * (/pages/traversine-lavabili): si attiva su qualunque pagina abbia il blocco
 * «Box confezioni» (snippets/product-information.liquid → [data-conf-config]).
 *
 * MODELLO (uguale a quello usato su Auròre per le federe di seta):
 *   • il prodotto della pagina è quello STORICO — recensioni, canali, SKU, storia
 *   • le confezioni da 2 e 3 sono PRODOTTI BUNDLE composti da quello
 *   • il selettore sceglie il prodotto giusto e ne scrive la variante nel form
 *
 * 🔑 DIFFERENZA VOLUTA RISPETTO AD AURÒRE: là i prezzi sono scritti a mano nel
 *    JS (`tot:'€83,30'`). Qui arrivano da /products/<handle>.js, cioè da
 *    Shopify. È la stessa classe di bug che su questo negozio aveva già fatto
 *    mostrare un prezzo diverso da quello addebitato.
 *
 * ⚠️ Si riscrivono `id` E `product-id` su TUTTI i form DEL BLOCCO D'ACQUISTO
 *    (modulo del carrello + modulo delle rate): scriverne uno solo manda il
 *    pagamento rapido (Shop Pay, PayPal) su un prodotto sbagliato.
 *
 * ⚠️ AMBITO (25/09/2026, revisione indipendente): tutto — moduli, taglie/colori,
 *    quantità, ascolto dei cambi — sta DENTRO il blocco d'acquisto della landing
 *    (`ZONA` = il #ProductInfo-<sezione> che contiene [data-conf-config]).
 *    Prima leggeva e scriveva su tutta la pagina: aprendo dal carrello l'anteprima
 *    rapida di un prodotto consigliato («Scegli opzioni») e cambiando taglia, il
 *    selettore riscriveva ANCHE quel modulo e nel carrello finiva la confezione di
 *    traversine al posto del prodotto scelto (e la landing prendeva la taglia
 *    dell'anteprima). Mai più `document.querySelectorAll` su moduli o radio.
 *
 * ⚠️ La quantità resta 1: il box È la quantità. Fino al 25/09/2026 custom.js la
 *    forzava a 2 e chi sceglieva «2 Tappetini» comprava 2 confezioni da 2.
 *    Ora custom.js si fa da parte sulle pagine con [data-conf-config], e qui la
 *    si riporta a 1 a ogni scelta di confezione (difesa in profondità).
 *
 * 🆕 30/09/2026 — anche sulla SCHEDA PRODOTTO /products/tappetino-igienico-per-cani
 *    (main-product). Lì dentro #ProductInfo- ci sono cose che la landing non ha:
 *    • la BARRA FISSA in basso (<product-add-to-cart-sticky>) con un SECONDO
 *      selettore colore/taglia (lì la taglia è un menu a tendina, non radio):
 *      i suoi fieldset venivano per ultimi e i box ci
 *      sarebbero finiti dentro. Si leggono solo i fieldset del selettore
 *      principale (#variant-selects-<sezione>); quelli della barra li riallinea
 *      il tema da solo (VariantSelects.updateOther). Il bottone della barra invia
 *      lo STESSO modulo (form="product-form-<sezione>"), quindi compra la
 *      confezione scelta: il prezzo che mostra ora è quello della confezione;
 *    • i prodotti complementari («Pairs well with»), che possono portare moduli
 *      e radio propri: si scrive solo nei due moduli del blocco
 *      (#product-form-<sezione> e #product-form-installment).
 *    Lì il file lo carica il blocco stesso (snippets/product-information.liquid):
 *    la guardia qui sotto evita la doppia esecuzione se il theme editor lo
 *    riesegue ridisegnando la sezione.
 *
 * 🆕 30/09/2026 — OFFERTA 1·3·6 sulla T1 (mockup di Matteo): i box non sono più per
 *    forza 1·2·3 pezzi. Quanti tappetini ha un box lo dice il prodotto collegato
 *    (metafield bundle.pezzi_inclusi, letto dal liquid: /products/*.js non espone i
 *    metafield; ripiego = numero del box). Prima il numero del box FACEVA da numero
 *    di pezzi: con 1·3·6 il box 2 avrebbe mostrato «36,35€ per tappetino» invece di
 *    24,23€ e la fascetta sarebbe finita sul box sbagliato. La fascetta ora segue il
 *    NUMERO DEL BOX. Tre elementi nuovi, tutti setting del blocco e spenti di default
 *    (le pagine che non li usano restano identiche):
 *    • sottotitolo sotto il nome;
 *    • vantaggi in elenco, uno per RIGA (a capo nella setting): una riga che comincia
 *      con 🎁 è un regalo in grassetto, le altre hanno la spunta verde. Il separatore
 *      NON è « + »: la principale e la scheda hanno già «Spedizione gratuita + Codice
 *      sconto…» su una riga sola, e deve restare una riga sola;
 *    • risparmio IN EURO in una fascia in fondo al box («RISPARMI 38€»), al posto del
 *      badge in percentuale: barrato − prezzo, in euro interi ARROTONDATI PER DIFETTO
 *      (109,80 → 109: il numero mostrato non supera mai il risparmio vero).
 *    [VALORE_REGALO] nei vantaggi = valore del prodotto in regalo (setting prodotto del
 *    blocco): il suo prezzo BARRATO, o quello di vendita se non ne ha (Matteo, 30/09:
 *    «usa il prezzo dello strike through»). Lo calcola il liquid. Se il prodotto non
 *    c'è, la riga non si mostra — un numero senza fonte non si scrive.
 */
(function () {
  if (window.__ccConfezioni) return;
  window.__ccConfezioni = true;

  var OPZIONE_TAGLIA = 'Taglia', OPZIONE_COLORE = 'Colore';

  var RIPIEGO = {
    '1': { nome: '1 Tappetino igienico', extra: '' },
    '2': { nome: '2 Tappetini igienici', extra: 'Spedizione gratuita' },
    '3': { nome: '3 Tappetini igienici', extra: 'Spedizione gratuita + Codice sconto per il prossimo acquisto' },
    handle: { '1': 'tappetino-igienico-per-cani', '2': '2-traversine-lavabili-per-cani', '3': '3-traversine-lavabili-per-cani' },
    fascetta_su: 3, fascetta: 'PIÙ VENDUTO - MIGLIOR PREZZO',
    // 25/09/2026, Matteo: «deve essere sempre 25%», «arrotonda 30 e 35».
    // Percentuali FISSE e tonde; il calcolo dal barrato resta come opzione.
    arrotonda: 'fisso', sconto: { '1': 25, '2': 30, '3': 35 },
    preselezionata: '1',
    // 30/09/2026 — offerta 1·3·6: di default tutto come prima
    risparmio: 'percentuale', risparmio_su_1: true, testo_risparmio: 'RISPARMI [EURO]', valore_regalo: 0
  };

  function config() {
    var el = document.querySelector('[data-conf-config]');
    if (!el) return RIPIEGO;
    try {
      var c = JSON.parse(el.textContent);
      c.fascetta_su = parseInt(c.fascetta_su, 10) || 0;
      // ripiego PER CHIAVE: un handle svuotato dall'editor non deve spegnere il
      // selettore (il theme editor ha già perso queste setting una volta, 05/09)
      // ⚠️ 30/09/2026 (revisione indipendente): il prodotto di ripiego si usa SOLO se il
      //    box descrive ancora QUEL prodotto (il suo nome di default). Con l'offerta 1·3·6
      //    un handle perso faceva comprare la confezione da 2 dal box «3 Tappetini +
      //    detersivo» (già scelto all'apertura): meglio un box in meno che una vendita
      //    diversa da quella descritta. Senza handle il box non si disegna.
      c.handle = c.handle || {};
      ['1', '2', '3'].forEach(function (t) {
        if (c.handle[t]) return;
        var nome = String((c[t] || {}).nome || '').trim();
        var descriveIlRipiego = nome === RIPIEGO[t].nome || nome === t + (t === '1' ? ' pezzo' : ' pezzi');
        c.handle[t] = descriveIlRipiego ? RIPIEGO.handle[t] : '';
      });
      c.preselezionata = ['1', '2', '3'].indexOf(String(c.preselezionata)) >= 0
        ? String(c.preselezionata) : RIPIEGO.preselezionata;
      if (['fisso', 'eccesso', 'matematico'].indexOf(c.arrotonda) < 0) c.arrotonda = RIPIEGO.arrotonda;
      var sc = c.sconto || {};
      c.sconto = {};
      ['1', '2', '3'].forEach(function (t) {
        var n = parseInt(sc[t], 10);
        c.sconto[t] = isNaN(n) ? RIPIEGO.sconto[t] : n;
        // pezzi del box: dal prodotto collegato (liquid); ripiego = numero del box
        c[t] = c[t] || RIPIEGO[t];
        var p = parseInt(c[t].pezzi, 10);
        c[t].pezzi = p > 0 ? p : parseInt(t, 10);
      });
      if (['percentuale', 'euro'].indexOf(c.risparmio) < 0) c.risparmio = RIPIEGO.risparmio;
      c.risparmio_su_1 = c.risparmio_su_1 !== false;
      c.testo_risparmio = c.testo_risparmio || RIPIEGO.testo_risparmio;
      c.valore_regalo = parseInt(c.valore_regalo, 10) || 0;
      return c;
    } catch (e) { return RIPIEGO; }
  }

  var CFG = RIPIEGO, DATI = {}, scelto = '1';
  // ZONA: il blocco d'acquisto; SEZIONE: la sezione intera (foto);
  // SEZ: l'id della sezione (template--…__main-product, …__featured_product_…),
  // che il tema usa per nominare selettore, moduli e quantità del blocco
  var ZONA = null, SEZIONE = null, SEZ = '', inAscolto = false;
  function zona() { return ZONA || document; }

  function euro(cent) { return (cent / 100).toFixed(2).replace('.', ',') + '€'; }

  // i testi vengono dalle setting del blocco: si scrivono come testo, non come HTML
  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  var SPUNTA = '<span class="conf__spunta" aria-hidden="true">' +
    '<svg viewBox="0 0 16 16" width="11" height="11"><path fill="#fff" d="M6.2 11.4 2.8 8l1.1-1.1 2.3 2.2 5-5L12.3 5z"/></svg></span>';
  var REGALO = '\uD83C\uDF81';   // 🎁

  // Vantaggi del box: uno per riga della setting. «🎁 …» = regalo in grassetto con
  // l'emoji al posto della spunta; [VALORE_REGALO] = valore del prodotto in regalo,
  // il suo barrato (se manca, la riga non si mostra). Una setting su una riga sola (la principale,
  // la scheda: «Spedizione gratuita + Codice sconto…») resta UNA riga, come prima.
  function righeVantaggi(testo) {
    return String(testo || '').split(/\r?\n/).map(function (r) { return r.trim(); })
      .filter(Boolean).map(function (r) {
        if (r.indexOf('[VALORE_REGALO]') >= 0) {
          if (!CFG.valore_regalo) return '';
          r = r.split('[VALORE_REGALO]').join(euro(CFG.valore_regalo));
        }
        if (r.indexOf(REGALO) === 0) {
          return '<span class="conf__extra conf__extra--regalo"><span class="conf__regalo" aria-hidden="true">' +
            REGALO + '</span>' + esc(r.slice(REGALO.length).trim()) + '</span>';
        }
        return '<span class="conf__extra">' + SPUNTA + esc(r) + '</span>';
      }).join('');
  }

  // ⚠️ selettori per ATTRIBUTO dentro la ZONA, non getElementById: l'anteprima
  // rapida del carrello porta un secondo #product-form-installment nella pagina,
  // e getElementById restituirebbe il primo che trova
  function perId(tag, id) { return zona().querySelector(tag + '[id="' + id + '"]'); }

  // i fieldset colore/taglia del selettore PRINCIPALE — non quelli della barra
  // fissa della scheda prodotto, né di altri prodotti ospitati nel blocco
  function fieldsetPrincipali() {
    var picker = SEZ ? perId('variant-selects', 'variant-selects-' + SEZ) : null;
    return Array.prototype.filter.call((picker || zona()).querySelectorAll('.product-form__input'),
      function (fs) { return !fs.closest('product-add-to-cart-sticky'); });
  }

  // i moduli del blocco: carrello + rate. Solo questi, mai quelli di altri prodotti
  function moduliDelBlocco() {
    if (SEZ) {
      var m = [perId('form', 'product-form-' + SEZ), perId('form', 'product-form-installment')]
        .filter(Boolean);
      if (m.length) return m;
    }
    return Array.prototype.slice.call(zona().querySelectorAll('form[action*="/cart/add"]'));
  }

  // un cambio di colore/taglia che riguarda il prodotto della pagina: dal
  // selettore principale o dalla barra fissa (che il tema riallinea al principale).
  // ⚠️ nella barra fissa la TAGLIA è un menu a tendina (<select>), non un radio:
  //    il tema passa alla barra picker_type 'dropdown' (prima riga di
  //    snippets/product-information.liquid). Ascoltando solo i radio, chi cambiava
  //    taglia dalla barra comprava il SINGOLO mentre il box diceva «2 Tappetini»
  //    (trovato dal banco qc_modulo.js il 30/09/2026, prima della pubblicazione).
  function cambioDelProdotto(t) {
    if (!t || !ZONA || !ZONA.contains(t)) return false;
    if (!SEZ) return t.type === 'radio';
    if (t.type !== 'radio' && t.tagName !== 'SELECT') return false;
    var vs = t.closest('variant-selects');
    return !!vs && (vs.id === 'variant-selects-' + SEZ || vs.id === 'variant-selects-' + SEZ + '--sticky');
  }

  function opzioniSelezionate() {
    var sel = {};
    fieldsetPrincipali().forEach(function (fs) {
      var et = fs.querySelector('.form__label');
      var r = fs.querySelector('input[type="radio"]:checked');
      if (et && r) sel[et.textContent.split(':')[0].trim()] = r.value;
    });
    return sel;
  }

  function indiceOpzione(d, nome) {
    for (var i = 0; i < d.options.length; i++) if ((d.options[i].name || d.options[i]) === nome) return i;
    return -1;
  }

  // Prezzo barrato = quello di RIFERIMENTO DELLA TAGLIA: il più alto fra i colori
  // della stessa taglia. In Shopify Bianco e Grigio hanno barrati più bassi del
  // Marrone (Bianco M 36,90 contro 43,90) e il box del singolo mostrava «-11%»:
  // la pagina vecchia mostrava per tutti i colori il barrato del Marrone, ed è
  // quello che Matteo vuole (25/09/2026). Sui bundle il barrato è già uguale.
  function barratoDi(tier, v) {
    var d = DATI[tier];
    if (!d || !v) return v ? v.compare_at_price : 0;
    var iT = indiceOpzione(d, OPZIONE_TAGLIA);
    if (iT < 0) return v.compare_at_price;
    var max = 0;
    d.variants.forEach(function (x) {
      if (x.options[iT] === v.options[iT] && x.compare_at_price > max) max = x.compare_at_price;
    });
    return max || v.compare_at_price;
  }

  // la variante del prodotto `tier` che combacia con colore e taglia correnti
  function variante(tier, sel) {
    var d = DATI[tier];
    if (!d) return null;
    return d.variants.filter(function (v) {
      return v.options.every(function (val, i) {
        var nome = d.options[i].name || d.options[i];
        return !sel[nome] || sel[nome] === val;
      });
    })[0] || null;
  }

  // 🔑 il pezzo che fa comprare la cosa giusta
  function scriviNelForm(tier, v) {
    if (!v) return;
    var pid = DATI[tier] && DATI[tier].id;
    moduliDelBlocco().forEach(function (f) {
      var idInput = f.querySelector('input[name="id"]');
      if (idInput) idInput.value = v.id;
      var pInput = f.querySelector('input[name="product-id"]');
      if (pInput && pid) pInput.value = pid;
    });
  }

  // la confezione scelta È la quantità: il selettore del tema torna a 1
  function quantitaUno() {
    var q = SEZ ? perId('input', 'Quantity-' + SEZ) : null;
    (q ? [q] : zona().querySelectorAll('quantity-selector .qty.quantity__input')).forEach(function (x) {
      x.value = 1;
    });
  }

  // Barra d'acquisto fissa in basso (c'è solo sulla scheda prodotto). Il suo
  // bottone compra la confezione scelta, quindi il prezzo che mostra è quello
  // della confezione — nello stesso formato del tema («€73,80 €51,80»), col
  // barrato di riferimento della taglia come nei box. Il tema lo ridisegna col
  // prezzo del singolo a ogni cambio di colore/taglia (renderProductInfo, fetch
  // asincrono): un osservatore rimette il nostro subito dopo il suo.
  var BARRA = { el: null, html: '', oss: null };
  function soldi(cent) {
    var p = (cent / 100).toFixed(2).split('.');
    var f = (window.theme && theme.settings && theme.settings.money_with_currency_format) ||
      '€{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1])
            .replace(/\{\{\s*amount\s*\}\}/, p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1]);
  }
  function aggiornaBarra(tier, v) {
    var el = SEZ ? perId('div', 'price-' + SEZ + '--sticky') : null;
    if (!el || !v) return;
    var barrato = barratoDi(tier, v), sconto = barrato && barrato > v.price;
    BARRA.html = '<span class="price" data-conf-prezzo="' + tier + '">' +
      (sconto ? '<del><span class="amount">' + soldi(barrato) + '</span></del>' : '') +
      '<ins><span class="amount' + (sconto ? ' discounted' : '') + '">' + soldi(v.price) + '</span></ins></span>';
    el.innerHTML = BARRA.html;
    if (BARRA.el !== el && window.MutationObserver) {   // nuovo elemento (anche dopo una ricarica dell'editor)
      if (BARRA.oss) BARRA.oss.disconnect();
      BARRA.el = el;
      BARRA.oss = new MutationObserver(function () {
        if (BARRA.html && !el.querySelector('[data-conf-prezzo]')) el.innerHTML = BARRA.html;
      });
      BARRA.oss.observe(el, { childList: true });
    }
  }

  // Prezzo dentro il bottone «Aggiungi al carrello» (29/10/2026, setting
  // `prezzo_bottone` del blocco, SPENTA di default: la landing principale, la T1
  // e la scheda prodotto restano com'erano). Stesso problema della barra fissa: il
  // tema ridisegna il bottone a ogni cambio di variante, quindi un osservatore
  // rimette il nostro testo subito dopo il suo. Si scrive solo dentro la zona del
  // blocco (regola 23), e mai quando la variante non è disponibile: lì il testo del
  // tema è «Esaurito» e aggiungerci un prezzo direbbe una bugia.
  var BOTT = { visti: [] };
  function scriviBottone(el) {
    var base = el.getAttribute('data-conf-base') || '';
    var prezzo = el.getAttribute('data-conf-prezzo') || '';
    var ora = (el.textContent || '').trim();
    var primo = ora.split(' \u00b7 ')[0];
    if (primo && primo !== base) {          // il tema ha cambiato il testo (es. «Esaurito»)
      base = primo;
      el.setAttribute('data-conf-base', base);
    }
    var atteso = prezzo ? base + ' \u00b7 ' + prezzo : base;
    if (ora !== atteso) el.textContent = atteso;
  }
  function aggiornaBottone(v) {
    if (!CFG.prezzo_bottone) return;
    [].slice.call(zona().querySelectorAll(
      'button[name="add"] .single-add-to-cart-button--text')).forEach(function (el) {
      if (BOTT.visti.indexOf(el) === -1) {
        BOTT.visti.push(el);
        el.setAttribute('data-conf-base', (el.textContent || '').trim());
        if (window.MutationObserver) {
          new MutationObserver(function () { scriviBottone(el); })
            .observe(el, { childList: true, characterData: true, subtree: true });
        }
      }
      // `euro()` e non `soldi()`: il simbolo va in fondo come nei box della pagina
      //    (soldi() usa il formato del tema, «€51,80», e sul bottone stonava)
      el.setAttribute('data-conf-prezzo', (v && v.available) ? euro(v.price) : '');
      scriviBottone(el);
    });
  }

  // (tolta il 25/09/2026 `aggiornaPrezzoTema`: cercava le classi .price-item* di
  //  Dawn, che il product-price di Vision non ha — non faceva nulla, e il prezzo
  //  del tema su queste landing è comunque nascosto da custom.css)

  function mostraImmagine(v) {
    if (!v || !v.featured_media) return;
    var sel = '[data-media-id$="-' + v.featured_media.id + '"]';
    var slide = (SEZIONE || document).querySelector(sel);
    if (!slide) return;
    var slider = slide.closest('product-slider');
    // il carosello è un Flickity: selectCell è la via giusta, spostare le
    // classi a mano non funziona perché le riscrive lui. `is-selected` è la
    // classe che si muove, `is-active` è statica dal server.
    if (slider && typeof slider.selectCell === 'function') {
      try { slider.selectCell(sel, false, true); } catch (e) {}
    }
  }

  // toglie l'altezza riservata del segnaposto della scheda prodotto (innocua altrove)
  function liberaSegnaposto(box) {
    if (!box) return;
    box.classList.remove('conf--attesa');
    box.removeAttribute('aria-busy');
  }

  function disegna() {
    var box = document.getElementById('conf-box');
    if (!box) return;
    var sel = opzioniSelezionate();
    box.innerHTML = '';
    liberaSegnaposto(box);            // stesso passo in cui arrivano i box: un solo ridisegno

    ['1', '2', '3'].forEach(function (tier) {
      var v = variante(tier, sel);
      if (!v) return;
      var t = CFG[tier] || { nome: tier, extra: '' };
      // tappetini nel box: dal prodotto collegato (bundle.pezzi_inclusi), non dal numero del box
      var pezzi = t.pezzi || parseInt(tier, 10);
      var barrato = barratoDi(tier, v);
      var scontato = barrato && barrato > v.price;
      var mostraRisparmio = scontato && (pezzi > 1 || CFG.risparmio_su_1);
      var risparmio = 0, fascia = '';
      if (mostraRisparmio && CFG.risparmio === 'euro') {
        // euro interi per DIFETTO: «RISPARMI 109€» per 109,80 — mai più del vero
        var eur = Math.floor((barrato - v.price) / 100);
        if (eur > 0) fascia = CFG.testo_risparmio.split('[EURO]').join(eur + '€');
      } else if (mostraRisparmio) {
        if (CFG.arrotonda === 'fisso') risparmio = (CFG.sconto && CFG.sconto[tier]) || 0;
        else risparmio = (CFG.arrotonda === 'matematico' ? Math.round : Math.ceil)((1 - v.price / barrato) * 100);
      }
      var vantaggi = righeVantaggi(t.extra);

      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'conf__box' + (tier === scelto ? ' is-scelto' : '') + (!v.available ? ' is-esaurito' : '');
      el.setAttribute('aria-pressed', tier === scelto ? 'true' : 'false');
      el.innerHTML =
        // la fascetta va sul NUMERO DEL BOX scelto nella setting (prima: sul numero di pezzi)
        (CFG.fascetta_su === parseInt(tier, 10) && CFG.fascetta
          ? '<span class="conf__fascetta">' + esc(CFG.fascetta) + '</span>' : '') +
        '<span class="conf__riga1">' +
          '<span class="conf__nome">' + esc(t.nome) + '</span>' +
          (risparmio ? '<span class="conf__badge">RISPARMI IL ' + risparmio + '%</span>' : '') +
        '</span>' +
        (t.sotto ? '<span class="conf__sotto">' + esc(t.sotto) + '</span>' : '') +
        '<span class="conf__riga2">' +
          '<span class="conf__prezzo">' + euro(v.price) + '</span>' +
          (scontato
            ? '<span class="conf__slash">/</span><s class="conf__barrato">' + euro(barrato) + '</s>' : '') +
          (pezzi > 1 ? '<span class="conf__cad">(' + euro(Math.round(v.price / pezzi)) + ' per ' + (CFG.unita || 'tappetino') + ')</span>' : '') +
        '</span>' +
        (vantaggi ? '<span class="conf__vantaggi">' + vantaggi + '</span>' : '') +
        (!v.available ? '<span class="conf__extra conf__extra--ko">Non disponibile</span>' : '') +
        (fascia ? '<span class="conf__risparmio">' + esc(fascia) + '</span>' : '');

      el.addEventListener('click', function () {
        if (!v.available) return;
        scelto = tier;
        applica(true);
      });
      box.appendChild(el);
    });
  }

  // azzera = true quando cambia la CONFEZIONE (primo disegno o clic su un box);
  // al cambio di taglia/colore la quantità la rimette a 1 il tema da solo
  // (product.js → renderProductInfo ridisegna #quantity-<sezione>).
  function applica(azzera) {
    var sel = opzioniSelezionate();
    var v = variante(scelto, sel);
    if (!v || !v.available) {           // confezione non disponibile: torna al singolo
      scelto = '1';
      v = variante('1', sel);
    }
    scriviNelForm(scelto, v);
    if (azzera) quantitaUno();
    mostraImmagine(variante('1', sel) || v);   // l'immagine è quella del colore
    aggiornaBarra(scelto, v);                  // solo dove c'è la barra fissa
    aggiornaBottone(v);                        // prezzo nel bottone, se la setting è accesa
    disegna();
  }

  function sistemaGuidaTaglie() {
    // resa dopo ogni fieldset: sulle pagine con più opzioni esce doppia,
    // e punta a href="#" perché questo prodotto non è fra gli id scritti a
    // mano in snippets/product-option.liquid.
    var g = zona().querySelectorAll('#product-size-guide-btn');
    for (var i = 1; i < g.length; i++) { g[i].hidden = true; g[i].classList.add('conf__guida-doppia'); }
    zona().querySelectorAll('#product-size-guide-btn a[href="#"]').forEach(function (a) {
      a.setAttribute('href', '/pages/taglie-tappetino-lavabile');
    });
  }

  function init() {
    var conf = document.querySelector('[data-conf-config]');
    if (!conf || conf.dataset.pronto === '1') return;
    conf.dataset.pronto = '1';
    // prodotti ricaricati da capo a ogni init: nel theme editor (shopify:section:load)
    // un handle svuotato deve far sparire il box anche lì, non usare i dati di prima
    // (revisione del 30/09/2026)
    DATI = {};
    ZONA = conf.closest('[id^="ProductInfo-"]') || conf.parentNode;
    SEZ = ZONA.id && ZONA.id.indexOf('ProductInfo-') === 0 ? ZONA.id.slice(12) : '';
    SEZIONE = conf.closest('.shopify-section') || document;
    CFG = config();
    scelto = CFG.preselezionata;       // setting «Confezione già scelta» del blocco
    sistemaGuidaTaglie();

    // il contenitore dei box va sotto l'ultimo fieldset di opzione E sotto la
    // «Guida alle taglie», che il tema rende subito dopo quel fieldset.
    // ⚠️ 14/09/2026, segnalato da Matteo: prima i box si inserivano FRA il
    //    fieldset Taglia e la guida, che finiva sotto i tre box invece che
    //    sotto le taglie come sulla landing originale. Su questo prodotto la
    //    guida è un <modal-opener class="product-popup-modal__opener">, sugli
    //    altri è #product-size-guide-btn (snippets/product-option.liquid):
    //    si saltano entrambi.
    // ⚠️ 30/09/2026: l'ultimo fieldset del SELETTORE PRINCIPALE, non di tutta la
    //    ZONA — sulla scheda prodotto l'ultimo sarebbe quello della barra fissa.
    // 30/09/2026: sulla scheda prodotto il server rende già #conf-box come segnaposto
    // (.conf--attesa, altezza riservata) perché lì il blocco sta sopra la piega: si usa
    // quello, spostandolo al solito posto. Sulle landing non c'è e si crea come prima.
    var box = (SEZIONE === document ? document : SEZIONE).querySelector('#conf-box');
    var fss = fieldsetPrincipali();
    // ⚠️ 29/10/2026 — prodotto SENZA opzioni (il guanto rimuovi pelo ha una variante sola).
    //    Non esiste un fieldset sotto cui appendere i box. Prima qui si usciva, e i box
    //    non comparivano. Ora: sulla scheda si usa il segnaposto #conf-box che il server
    //    ha già reso al posto giusto; sulla landing (dove il segnaposto non c'è) si crea
    //    il box subito sopra il modulo d'acquisto.
    //    Sui prodotti con opzioni — le traversine — `fss` non è mai vuoto e non cambia nulla.
    if (!fss.length) {
      if (!box) {
        var ancora = ZONA.querySelector('.product--product-form, product-form, .product-form');
        if (!ancora) { liberaSegnaposto(box); return; }
        box = document.createElement('div');
        box.className = 'conf'; box.id = 'conf-box';
        ancora.parentNode.insertBefore(box, ancora);
      }
    } else {
      var dopo = fss[fss.length - 1];
      while (dopo.nextElementSibling &&
             dopo.nextElementSibling.matches('modal-opener.product-popup-modal__opener, #product-size-guide-btn')) {
        dopo = dopo.nextElementSibling;
      }
      if (!box) {
        box = document.createElement('div');
        box.className = 'conf'; box.id = 'conf-box';
      }
      dopo.parentNode.insertBefore(box, dopo.nextSibling);
    }

    var handles = CFG.handle || RIPIEGO.handle;
    Promise.all(['1', '2', '3'].map(function (t) {
      if (!handles[t]) return null;        // box senza prodotto: non si disegna
      return fetch('/products/' + handles[t] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d) DATI[t] = d; })
        .catch(function () {});
    })).then(function () {
      if (!DATI['1']) { liberaSegnaposto(box); return; }   // senza il prodotto base non si fa nulla
      // ⚠️ fuori dalla catena: un errore qui non deve passare per «fetch fallito»
      setTimeout(function () {
        applica(true);
        // UN solo ascoltatore per tutta la vita della pagina (il theme editor
        // rifà init a ogni ricarica di sezione), e solo per i radio della ZONA
        // corrente: quelli dell'anteprima rapida nel carrello non ci riguardano.
        if (!inAscolto) {
          inAscolto = true;
          document.addEventListener('change', function (e) {
            if (cambioDelProdotto(e.target))
              setTimeout(function () { applica(false); }, 60);
          });
        }
      }, 0);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
